module.exports = __webpack_public_path__ + "static/media/myDrumMachine.c4f34920.png";